import { CircularProgress, Grid } from '@mui/material';
import { useState } from 'react';
import { Query } from '@features/redux/apis/utils';
import { useSystemConfigMutation, useSystemConfigQuery } from '@features/redux/apis/system';
import { ForceOffsetHeader } from './ForceOffsetHeader';
import { ForceEffects } from './ForceEffects';
import { ForceMaterials } from './ForceMaterials';
import { useAlert } from '@hooks/useAlert';

const DEFAULT_DRAFT = {};

const useSystemConfig = Query.withDraft(useSystemConfigQuery, DEFAULT_DRAFT);

export const ForceOffset = ({
    productId,
    serialNumber,
}: {
    productId?: string | null;
    serialNumber: string | null | undefined;
}) => {
    const { setAlert } = useAlert();

    if (!serialNumber) return null;

    const completeDisable = productId === null || productId === undefined;

    const [unlocked, setUnlocked] = useState(false);

    const { isLoading, draft } = useSystemConfig({ serialNumber });
    const [state, dispatch] = draft;

    const [mutate, { isLoading: mutationLoading }] = useSystemConfigMutation({
        fixedCacheKey: 'ForceOffsetMutation',
    });

    const onSave = async () => {
        try {
            const resp: any = await mutate({
                serialNumber,
                config: state!,
            });

            if (resp?.error?.status) throw new Error(resp.status);
            setUnlocked(false);
        } catch (e) {
            setAlert('Failed to save configuration!', 'error');
        }
    };

    return (
        <Grid
            item
            xs={12}
            sm={12}
            md={6}
            gap={2}
            display={'flex'}
            flex={1}
            mt={'20px'}
            width={'100%'}
            maxWidth={'100% !important'}
            flexDirection={'column'}
            justifyContent={'center'}>
            <ForceOffsetHeader
                productId={productId!}
                disabled={completeDisable || mutationLoading}
                loading={mutationLoading}
                unlocked={unlocked}
                onSave={onSave}
                unlock={setUnlocked}
            />
            {isLoading ? (
                <CircularProgress size='3rem' />
            ) : (
                <ForceMaterials productId={productId!} unlocked={unlocked} state={state} dispatch={dispatch} />
            )}

            <ForceEffects />
        </Grid>
    );
};
